import { render } from "./singleMarketComponent.vue?vue&type=template&id=97625590"
import script from "./singleMarketComponent.vue?vue&type=script&lang=js"
export * from "./singleMarketComponent.vue?vue&type=script&lang=js"

import "./singleMarketComponent.vue?vue&type=style&index=0&id=97625590&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__